<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-import"></i> Importação</h3>
      </div>
    </div>
    <ImportAdd v-if="showAdd" ref="ImportAdd" v-on:Back="onBack" />
    <ImportList v-else ref="ImportList" v-on:Upload="onUpload" />
  </div>
</template>
<script>
import ImportAdd from './components/add/importadd.vue'
import ImportList from '@/views/private/import/components/list/importlist.vue'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools'

export default {
  name: 'Import',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ImportAdd,
    ImportList
  },
  methods: {
    onUpload () {
      this.showAdd = true
    },
    onBack () {
      loading.push()
      this.showAdd = false
      loading.close()
    },
    onLoad () {
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/import/import.vue